import type { RefObject } from 'react';

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { EditorRefHandle } from '~/components';

import { Button } from '~/components';
import { Form } from '~/components/Form';

import type { ForumCommentFieldValues } from './ForumCommentEditorField';

import { ForumCommentEditorField } from './ForumCommentEditorField';
import { formButtonsStyle, formStyle } from './ForumCommentForm.css';

type Props = {
  commentEditorRef: RefObject<EditorRefHandle | null>;
  loading: boolean;
  onSubmit: (data: ForumCommentFieldValues) => void;
};

export const CreateForumCommentForm = ({ commentEditorRef, loading, onSubmit }: Props) => {
  const { control, handleSubmit } = useForm<ForumCommentFieldValues>({
    defaultValues: {
      content: { type: 'doc', content: [] },
    },
  });

  const { t } = useTranslation(['forum']);

  return (
    <Form className={formStyle} onSubmit={handleSubmit(onSubmit)}>
      <ForumCommentEditorField control={control} ref={commentEditorRef} />

      <div className={formButtonsStyle}>
        <Button icon="Send" loading={loading} type="submit">
          {t('forum:createComment.actions.comment')}
        </Button>
      </div>
    </Form>
  );
};
